import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { FormsModule } from '@angular/forms';
import { CustomerPlanItemCancelReasonDialogComponent } from './customer-plan-item-cancel-reason-dialog.component';
import { DialogContainerModule } from 'src/app/shared/dialog-container/dialog-container.module';



@NgModule({
  declarations: [CustomerPlanItemCancelReasonDialogComponent],
  imports: [
    CommonModule,
    AngularMaterialModule,
    FormsModule,
    DialogContainerModule,
  ]
})
export class CustomerPlanItemCancelReasonDialogModule { }
